import './App.css'
import { ThemeProvider } from '@mui/material/styles'
import theme from './theme' // Import your theme here
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import ConfirmationModalContextProvider from './context/ConfirmationModalContext'
import AuthProvider from './context/AuthContext'
import { BrowserRouter } from 'react-router-dom'
import { CssBaseline } from '@mui/material'
import AppLayout from './component/appLayout/AppLayout'

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ConfirmationModalContextProvider>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <AppLayout />
            <ToastContainer position='bottom-right' newestOnTop />
          </ThemeProvider>
        </ConfirmationModalContextProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
